'use client';

import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { OverlayToaster, Toaster } from '@blueprintjs/core';
import { createRoot } from 'react-dom/client';

const ToasterContext = createContext<Toaster | null>(null);

export default function ToasterProvider({ children }) {
    const [toaster, setToaster] = useState<Toaster | null>(null);

    const createToaster = useCallback(
        async () => {
            const newToaster = await OverlayToaster.createAsync(
                {},
                {
                    domRenderer: (t, containerElement) => createRoot(containerElement).render(t),
                }
            );
            setToaster(newToaster);
        },
        [setToaster],
    );

    useEffect(
        () => {
            createToaster();
        },
        [createToaster],
    );

    return (
        <ToasterContext.Provider value={toaster}>
            {children}
        </ToasterContext.Provider>
    );
}

export function useToaster() {
    return useContext(ToasterContext);
}
